import type { TFunction } from 'i18next'
import type { SessionParticipant } from '~/gql/sessions/sessions'
import { formatSeconds } from '~/helpers/learner/duration'
import { DROPOUT_REASON_KEYS, PARTICIPANT_STATUS_KEYS, participantStatus } from './participant-state'

/**
 * Résultats d'une session en CSV (#243) : une ligne par participant affiché.
 * Construit côté navigateur à partir des lignes déjà chargées — la fiche les
 * lit toutes d'un coup —, avec les définitions de l'écran.
 */
export function participantsCsv(
  participants: readonly SessionParticipant[],
  t: TFunction,
  formatDate: (value: unknown) => string,
): { headers: string[], rows: string[][] } {
  return {
    headers: [
      t('common.lastname'),
      t('common.firstname'),
      t('stats.export.email'),
      t('common.groups'),
      t('user.progress.label'),
      t('sessionDetail.participants.modules'),
      t('common.score'),
      t('common.totalTime'),
      t('sessionDetail.participants.lastActivity'),
      t('sessionDetail.dropout.reason.label'),
    ],
    rows: participants.map(p => [
      p.lastName ?? '',
      p.firstName ?? '',
      p.email ?? '',
      p.groups.join(', '),
      t(PARTICIPANT_STATUS_KEYS[participantStatus(p)]),
      `${p.completedModules}/${p.totalModules}`,
      p.averageScorePercent != null ? `${p.averageScorePercent} %` : '',
      formatSeconds(p.timeSpentSeconds, t) ?? '',
      p.lastActivityAt ? formatDate(p.lastActivityAt) : '',
      p.dropReason ? t(DROPOUT_REASON_KEYS[p.dropReason]) : '',
    ]),
  }
}
